import { Component, Input } from "@angular/core";
import { SearchResultItemModel } from "apps-module/app/entry-modules/event-search/models/search-result-item.model";
import { SearchStatus } from "apps-module/app/shared-library/enums/search-status.enum";

@Component({
    selector: "[pcg-ng-search-results]",
    templateUrl: "./search-results.component.html",
    providers: []
})
export class SearchResultsComponent {

    @Input()
    public results: Array<SearchResultItemModel> = [];

    public readonly statuses = SearchStatus;

    @Input()
    public searchStatus: SearchStatus = SearchStatus.Loading;
}
